import type { ReactNode } from 'react';
import TimelineProvider from './timeline';

type ProvidersProps = {
  children: ReactNode;
};
export default function AbsenceProviders({ children }: ProvidersProps) {
  return <TimelineProvider>{children}</TimelineProvider>;
}
